var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlanco2023(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-29e29495-ca15-413a-b1ff-bc3560f3f310",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.52 70.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-d4ab46e9-26ba-46ae-a7c9-4418e8ef8ed2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.79,26.88c2.51-2.45,6.47-2.66,9.22-.62.45.33,1.09.27,1.49-.12l2.74-2.67c.49-.48.44-1.27-.1-1.7-5.19-4.16-12.88-3.88-17.72.86-1.67,1.63-2.79,3.58-3.38,5.65-.21.73.36,1.44,1.12,1.44h4.07c.47,0,.89-.29,1.07-.71.34-.77.83-1.49,1.47-2.12",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.79,36.61c-.57-.55-1.02-1.18-1.35-1.85-.18-.36-.55-.59-.96-.59H1.15c-.72,0-1.23.69-1.02,1.37.61,1.96,1.71,3.8,3.29,5.35,2.57,2.52,5.95,3.77,9.34,3.77,3.03,0,6.05-1.01,8.5-3.01.48-.39.49-1.1.05-1.53l-2.87-2.81c-.39-.38-.99-.39-1.42-.07-2.76,2.05-6.72,1.84-9.23-.61",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.22,44.11h4.45c.49,0,.89-.39.89-.87v-12.67c0-.48-.4-.87-.89-.87h-4.45c-.49,0-.89.39-.89.87v12.67c0,.48.4.87.89.87Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.73,25.22h21.3c.39,0,.71-.31.71-.7v-4.05c0-.39-.32-.7-.71-.7h-21.3c-.39,0-.71.31-.71.7v4.05c0,.39.32.7.71.7Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.25,44.11h-4.95c-.35,0-.64-.28-.64-.63v-10.43c0-.49.54-.79.97-.54l4.95,2.94c.19.11.31.32.31.54v7.49c0,.35-.29.63-.64.63Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.67,27l-10.88-6.55c-.5-.3-1.13.05-1.13.62v5.28c0,.26.14.49.36.63l11.66,6.87c.24.14.53.14.76,0l4.7-2.76c.5-.29,1.13.06,1.13.63v11.67c0,.4.33.73.74.73h4.71c.41,0,.74-.33.74-.73v-22.31c0-.57-.64-.92-1.13-.62l-10.88,6.55c-.24.14-.54.14-.78,0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.51,4.35l-2.45,1.47c-.8-1.2-2.1-1.92-3.69-1.92-2.59,0-4.51,1.85-4.51,4.57.01,2.8,1.99,4.57,4.51,4.57,1.58,0,2.87-.7,3.72-1.91l2.33,1.63c-1.26,1.81-3.42,2.95-6.03,2.95-4.4,0-7.5-3.04-7.5-7.24s3.1-7.24,7.5-7.24c2.63,0,4.96,1.18,6.12,3.13",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.96,10.59c0,.3-.02.66-.05.88h-7.01c.29,1.4,1.29,2.01,2.54,2.01.85,0,1.78-.34,2.5-.93l1.56,1.68c-1.12,1.01-2.55,1.47-4.21,1.47-3.03,0-5.13-2.02-5.13-5.05s2.04-5.12,5-5.12,4.79,2.07,4.8,5.08m-7.05-.9h4.38c-.25-1.24-1.01-1.94-2.16-1.94-1.25,0-1.99.74-2.22,1.94",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.49,9.28v6.15h-2.66v-5.31c0-1.39-.71-2.16-1.93-2.16-1.14,0-2.09.73-2.09,2.18v5.29h-2.66V5.77h2.59v1.14c.7-1.03,1.79-1.4,2.91-1.4,2.24,0,3.85,1.53,3.85,3.77",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.39,8.08h-3.58v3.53c0,1.21.65,1.65,1.48,1.65.63,0,1.31-.31,1.86-.63l.98,2.03c-.87.58-1.87,1.02-3.28,1.02-2.45,0-3.7-1.36-3.7-3.86v-3.74h-1.91v-2.31h1.91v-2.87h2.66v2.87h3.58v2.31Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.5,5.72l-.4,2.58c-.44-.19-1.07-.31-1.61-.31-1.23,0-2.08.74-2.08,2.17v5.26h-2.66V5.77h2.58v1.06c.62-.91,1.57-1.32,2.79-1.32.57,0,1.02.08,1.39.21",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.41,10.6c0,2.91-2.28,5.08-5.35,5.08s-5.34-2.17-5.34-5.08,2.26-5.09,5.34-5.09,5.35,2.18,5.35,5.09m-7.98,0c0,1.56,1.12,2.66,2.62,2.66s2.63-1.1,2.63-2.66-1.13-2.66-2.63-2.66-2.62,1.09-2.62,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.33 41.09 114.49 41.09 114.49 30.55 110.96 39.75 107.95 39.75 104.42 30.63 104.42 41.09 101.57 41.09 101.57 27.13 105.75 27.13 109.46 36.55 113.16 27.13 117.33 27.13 117.33 41.09",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.57,36.25c0,.3-.02.66-.06.88h-7c.28,1.4,1.28,2,2.54,2,.86,0,1.78-.34,2.5-.92l1.56,1.67c-1.12,1.01-2.55,1.47-4.21,1.47-3.03,0-5.13-2.01-5.13-5.05s2.04-5.12,5-5.12,4.8,2.07,4.81,5.08m-7.06-.9h4.38c-.25-1.24-1.01-1.94-2.16-1.94-1.25,0-1.99.74-2.22,1.94m.44-5.3l2.05-3.14h3.18l-2.69,3.14h-2.54Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.83,32.44v-5.7h2.65v14.36h-2.6v-1.06c-.64.78-1.6,1.31-2.96,1.31-2.72,0-4.78-2.18-4.78-5.08s2.06-5.09,4.78-5.09c1.33,0,2.27.51,2.91,1.27m-4.96,3.82c0,1.47.98,2.66,2.54,2.66s2.55-1.13,2.55-2.66-1.03-2.66-2.55-2.66-2.54,1.19-2.54,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.32,28.27c0,.94-.75,1.65-1.7,1.65s-1.7-.72-1.7-1.65.73-1.68,1.7-1.68,1.7.74,1.7,1.68m-.36,12.82h-2.66v-9.66h2.66v9.66Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.37,32.99l-1.92,1.57c-.6-.63-1.24-.97-2.11-.97-1.38,0-2.48,1.06-2.48,2.66s1.09,2.66,2.47,2.66c.85,0,1.59-.38,2.15-.98l1.9,1.59c-.93,1.17-2.32,1.81-3.97,1.81-3.15,0-5.27-2.16-5.27-5.08s2.11-5.09,5.27-5.09c1.65,0,3.05.66,3.96,1.82",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.39,36.26c0,2.91-2.28,5.08-5.36,5.08s-5.33-2.17-5.33-5.08,2.26-5.09,5.33-5.09,5.36,2.17,5.36,5.09m-7.98,0c0,1.56,1.12,2.66,2.62,2.66s2.63-1.1,2.63-2.66-1.13-2.66-2.63-2.66-2.62,1.09-2.62,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.71,32.44v-5.7h2.65v14.36h-2.6v-1.06c-.64.78-1.6,1.31-2.96,1.31-2.72,0-4.78-2.18-4.78-5.08s2.06-5.09,4.78-5.09c1.33,0,2.27.51,2.91,1.27m-4.97,3.82c0,1.47.99,2.66,2.55,2.66s2.55-1.13,2.55-2.66-1.03-2.66-2.55-2.66-2.55,1.19-2.55,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.36,36.25c0,.3-.02.66-.05.88h-7.01c.29,1.4,1.29,2,2.54,2,.86,0,1.79-.34,2.5-.92l1.56,1.67c-1.12,1.01-2.55,1.47-4.21,1.47-3.03,0-5.13-2.01-5.13-5.05s2.04-5.12,5-5.12,4.79,2.07,4.8,5.08m-7.05-.9h4.38c-.25-1.24-1.01-1.94-2.15-1.94-1.25,0-1.99.74-2.22,1.94",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.55,
    y: 26.73,
    width: 2.66,
    height: 14.36,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.98 55.39 107.55 55.39 107.55 66.75 104.71 66.75 104.71 55.39 100.28 55.39 100.28 52.79 111.98 52.79 111.98 55.39",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.47,57.04l-.4,2.59c-.44-.19-1.07-.31-1.61-.31-1.23,0-2.08.74-2.08,2.18v5.26h-2.67v-9.66h2.58v1.06c.62-.91,1.58-1.32,2.79-1.32.57,0,1.02.08,1.39.21",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.03,66.75h-2.6v-1.07c-.64.78-1.6,1.32-2.96,1.32-2.72,0-4.78-2.19-4.78-5.09s2.06-5.09,4.78-5.09c1.36,0,2.31.54,2.96,1.33v-1.07h2.6v9.66Zm-7.62-4.83c0,1.48.99,2.66,2.55,2.66s2.55-1.13,2.55-2.66-1.03-2.66-2.55-2.66-2.55,1.19-2.55,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.18,61.91c0,2.9-2.06,5.09-4.78,5.09-1.36,0-2.31-.54-2.96-1.32v1.07h-2.6v-14.36h2.65v5.7c.64-.76,1.57-1.27,2.9-1.27,2.73,0,4.79,2.18,4.79,5.09m-7.82,0c0,1.53,1.03,2.66,2.54,2.66s2.54-1.18,2.54-2.66-.97-2.66-2.54-2.66-2.54,1.14-2.54,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.1,66.75h-2.6v-1.07c-.65.78-1.61,1.32-2.96,1.32-2.72,0-4.78-2.19-4.78-5.09s2.06-5.09,4.78-5.09c1.36,0,2.3.54,2.96,1.33v-1.07h2.6v9.66Zm-7.62-4.83c0,1.48.99,2.66,2.55,2.66s2.55-1.13,2.55-2.66-1.03-2.66-2.55-2.66-2.55,1.19-2.55,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162.62,67.67c0,2.11-1.25,3.28-3.07,3.28-.48,0-1.12-.1-1.5-.26l.4-2.29c.23.08.46.12.72.12.45,0,.8-.27.8-1.01v-10.43h2.66v10.58Zm.34-13.74c0,.94-.74,1.66-1.7,1.66s-1.69-.72-1.69-1.66.73-1.68,1.69-1.68,1.7.74,1.7,1.68",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.15,66.75h-2.6v-1.07c-.64.78-1.6,1.32-2.96,1.32-2.72,0-4.79-2.19-4.79-5.09s2.07-5.09,4.79-5.09c1.36,0,2.3.54,2.96,1.33v-1.07h2.6v9.66Zm-7.62-4.83c0,1.48.99,2.66,2.55,2.66s2.55-1.13,2.55-2.66-1.03-2.66-2.55-2.66-2.55,1.19-2.55,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.04,58.09v-5.7h2.65v14.36h-2.6v-1.07c-.64.78-1.6,1.32-2.96,1.32-2.72,0-4.78-2.19-4.78-5.09s2.06-5.09,4.78-5.09c1.33,0,2.26.51,2.91,1.27m-4.97,3.82c0,1.48.99,2.66,2.55,2.66s2.55-1.13,2.55-2.66-1.03-2.66-2.55-2.66-2.55,1.19-2.55,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.58,61.91c0,2.91-2.27,5.09-5.35,5.09s-5.33-2.17-5.33-5.09,2.26-5.09,5.33-5.09,5.35,2.17,5.35,5.09m-7.97,0c0,1.56,1.12,2.66,2.62,2.66s2.63-1.1,2.63-2.66-1.13-2.66-2.63-2.66-2.62,1.1-2.62,2.66",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.52,57.04l-.4,2.59c-.44-.19-1.07-.31-1.61-.31-1.23,0-2.08.74-2.08,2.18v5.26h-2.66v-9.66h2.58v1.06c.62-.91,1.57-1.32,2.78-1.32.57,0,1.02.08,1.39.21",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.21,
    width: 2.42,
    height: 69.68,
    fill: "#fff",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlanco2023);
export default __webpack_public_path__ + "static/media/LogoBlanco2023.cd209553e6d4d023ed0cc8c1ab93b64b.svg";
export { ForwardRef as ReactComponent };